import { createRef, createElement, Component } from 'react';
import { node } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import _get from 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized, b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import { TableCell as TableCell$1 } from './styled.js';
var tableCellPropTypes = {
  children: node
};
var tableCellDefaultProps = {
  children: undefined
};

var TableCell = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TableCell, _React$Component);

  function TableCell() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      title: undefined
    });

    _defineProperty(_assertThisInitialized(_this), "tableCellRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_get(_assertThisInitialized(_this), 'tableCellRef.current')) {
        // @ts-ignore
        var cellIndex = _this.tableCellRef.current.cellIndex; // @ts-ignore

        var rowElement = _this.tableCellRef.current.parentNode;
        var bodyElement = rowElement.parentNode;
        var tableElement = bodyElement.parentNode;

        var tableElementChildren = _get(tableElement, 'childNodes', []);

        if (tableElementChildren.length > 0) {
          // @ts-ignore
          NodeList.prototype.find = Array.prototype.find;
          var headElement = tableElementChildren.find(function (child) {
            return child.tagName === 'THEAD';
          });

          if (headElement && headElement.childNodes) {
            var headRowElement = _get(headElement, 'childNodes[0]');

            var headCellElement = _get(headRowElement, "childNodes[" + cellIndex + "]");

            _this.setState({
              title: _get(headCellElement, 'innerText')
            });
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

      var title = _this.state.title;
      return createElement(TableCell$1, _extends({
        use: "td",
        "data-content": title
      }, props, {
        elementRef: _this.tableCellRef
      }), children);
    });

    return _this;
  }

  return TableCell;
}(Component); // @ts-ignore


_defineProperty(TableCell, "propTypes", tableCellPropTypes);

_defineProperty(TableCell, "defaultProps", tableCellDefaultProps);

var C = TableCell;
export default C;
export { TableCell, tableCellDefaultProps, tableCellPropTypes };